<template>
  <grid :items="apps" mode="application" :cols="3" :perPage="-1" />
</template>

<script>
import Grid from "@/components/grid"
import Applications from "@/api/applications"
export default {
  name: "Applications",
  components: { Grid },
  data() {
    return {
      apps: []
    }
  },
  mounted() {
    this.setBusy(true)
      Applications.list().then(response => {
        this.apps = response.data
      }).finally(() => this.setBusy(false))
  }
}
</script>
